import React from "react";
import { FiHelpCircle } from "react-icons/fi";
import { Link } from "react-router-dom";
import { formatPrice, siteConfig } from "../Datas/productData";
import "../css/privacy.scss";

function Faqs() {
  const sections = [
    ["faq-orders", "Orders"],
    ["faq-delivery", "Delivery"],
    ["faq-returns", "Returns"],
    ["faq-products", "Products"],
    ["faq-contact", "Contact"],
  ];

  return (
    <main className="privacy-page">
      <header className="privacy-page__hero">
        <FiHelpCircle aria-hidden="true" />
        <p>Customer care</p>
        <h1>Frequently asked questions</h1>
        <span>Helpful answers before and after you order</span>
      </header>
      <div className="privacy-page__layout">
        <aside aria-label="FAQ contents">
          <p>On this page</p>
          <nav>{sections.map(([id, label], index) => <a href={`#${id}`} key={id}><span>{String(index + 1).padStart(2, "0")}</span>{label}</a>)}</nav>
        </aside>
        <article>
          <section id="faq-orders"><p className="privacy-page__section-number">01</p><h2>Orders and payment</h2><p>Orders can be placed as a guest. Available payment methods and the final total appear at checkout before you confirm payment.</p><p>If you need to change an order, contact us as soon as possible. Once fulfilment begins, changes or cancellation may no longer be possible.</p></section>
          <section id="faq-delivery"><p className="privacy-page__section-number">02</p><h2>Delivery</h2><p>Standard delivery costs {formatPrice(siteConfig.shipping.standard)} and is free when the bag value reaches {formatPrice(siteConfig.shipping.freeThreshold)}. Estimated timing is shown during checkout.</p><p>Tracking details are emailed after dispatch. Read our <Link to="/shipping">delivery information</Link> for further guidance.</p></section>
          <section id="faq-returns"><p className="privacy-page__section-number">03</p><h2>Returns and refunds</h2><p>Eligible items may be returned within {siteConfig.shipping.returnDays} days of delivery, unused and complete with labels and accessories.</p><p>See the <Link to="/returns">returns page</Link> for the registration steps, exclusions and refund timing.</p></section>
          <section id="faq-products"><p className="privacy-page__section-number">04</p><h2>Products and care</h2><p>Dimensions, materials, closures and straps are listed on each product page. Natural leather may show small variations in grain and tone.</p><p>Store bags away from direct heat and sunlight, fill them lightly to support their shape and use only care products suitable for the stated material.</p></section>
          <section id="faq-contact" className="privacy-page__contact"><p className="privacy-page__section-number">05</p><h2>Still need help?</h2><p>Our customer-care team is available {siteConfig.contact.hours}.</p><a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a><span>{siteConfig.legalName}</span><span>{siteConfig.contact.location}</span></section>
        </article>
      </div>
    </main>
  );
}

export default Faqs;
